import Auth from './Auth';

export default Auth;


// WEBPACK FOOTER //
// ./src/Services/Auth/index.tsx